import React from 'react'
import ContextMenuItem from './ContextMenuItem'
import { AFFICHER_REGION } from './contextmenu.constants'
import { useT } from '../../i18n/T'
import { useAction, withEverySelectorTruthy } from '../../utils/react-redux'
import { searchRegionFromPoint } from '../../../store/address/address.actions'
import { selectIsPlacesUniverse } from '../../../store/history/history.selectors'

const ContextMenuItemShowCity = () => {
  const label = useT('map.context-menu.show-region')
  const execSearchLocation = useAction(searchRegionFromPoint)

  return <ContextMenuItem tagAction={AFFICHER_REGION} label={label} clickAction={execSearchLocation} />
}

export default withEverySelectorTruthy(selectIsPlacesUniverse)(ContextMenuItemShowCity)
